// extracted by mini-css-extract-plugin
export default {"submittedFeedbackButton":"Feedback-module__submittedFeedbackButton--P_4a2"};